<template>
  <div class="PaB-product-filters">
    <label class="PaB-filter-price-label">Price Range</label>
    <vue-slider v-model="tempFilters.priceRange" :min="maxPriceRange[0]" :max="maxPriceRange[1]" formatter="${value}" :interval="1" tooltip-dir="bottom" :processStyle="{backgroundColor: widgetOptions.style.color_primary}" :tooltipStyle="{backgroundColor: widgetOptions.style.color_primary, borderColor: widgetOptions.style.color_primary}"></vue-slider>

    <accordion title="Brand" max-height="calc(100vh - 300px)" height="300px" @open="accordionOpened">
      <checkbox v-for="brand in allBrands" :key="brand" v-model="tempFilters.brand" :value="brand">{{ brand }}</checkbox>
    </accordion>

    <app-button @click.native="apply" classes="PaB-apply-filters" type="primary" :rounded="true" label="Apply Filters"></app-button>
  </div>
</template>

<style lang="scss" scoped>
.PaB-filter-price-label {
  font-weight: normal;
}
.vue-slider-component {
  margin-bottom: 45px;
}
.PaB-app-accordion {
  margin-bottom: 15px;
}
.PaB-apply-filters {
  width: 100%;
  margin-top: 15px;
}
</style>

<script>
import Checkbox from '@/components/Checkbox'
import VueSlider from 'vue-slider-component'
import AppButton from '@/components/AppButton'
import Accordion from '@/components/Accordion'

export default {
  data: function () {
    return {
      tempFilters: {}
    }
  },

  components: {
    Checkbox,
    VueSlider,
    AppButton,
    Accordion
  },

  computed: {
    allStrains () {
      return this.$store.getters['products/getStrains']
    },
    allBrands () {
      return this.$store.getters['products/getBrands']
    },
    maxPriceRange () {
      return this.$store.getters['products/getPriceRange']
    }
  },

  created () {
    this.tempFilters = { ...this.$store.state.products.filters }

    this.$store.watch((state) => {
      return this.$store.state.products.filters // could also put a Getter here
    }, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        this.tempFilters = { ...newValue }
      }
    }, { deep: true })
  },

  methods: {
    accordionOpened () {
      this.$emit('accordionOpened')
    },
    apply: function () {
      this.$emit('filtered', this.tempFilters)
      this.$store.dispatch('products/filter', this.tempFilters)

      // route to all products if on home page
      const currentRoute = this.$router.currentRoute.fullPath
      if (currentRoute === '/') {
        this.$router.push({ name: 'product-listing', params: { category: 'all' } })
      }
    }
  }
}
</script>
